import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: ${({ preview }) => (preview ? 'fit-content' : '100%')};
  display: flex;
  align-items: ${({ preview }) => (preview ? 'flex-start' : 'center')};
  justify-content: center;
  padding: ${({ preview }) => (preview ? '0' : '0')};
  background: transparent;
  overflow: ${({ preview }) => (preview ? 'visible' : 'hidden')};
`;

export const Card = styled.div`
  background: #fff;
  border-radius: ${({ preview }) => (preview ? '8px' : '12px')};
  max-width: 100%;
  width: 100%;
  font-family: 'Poppins', sans-serif;
  min-height: fit-content;
  margin: 0 auto;
  padding: ${({ preview }) => (preview ? '4px' : '16px')};

  @media (max-width: 768px) {
    padding: ${({ preview }) => (preview ? '6px' : '12px')};
  }

  @media (max-width: 480px) {
    padding: ${({ preview }) => (preview ? '4px' : '8px')};
  }

  @media (min-width: 1200px) {
    padding: ${({ preview }) => (preview ? '6px' : '20px')};
  }

  @media (min-width: 1440px) {
    padding: ${({ preview }) => (preview ? '8px' : '24px')};
  }

  @media (min-width: 1680px) {
    padding: ${({ preview }) => (preview ? '6px' : '20px')};
  }

  @media (min-width: 1920px) {
    padding: ${({ preview }) => (preview ? '12px' : '25px')};
  }
  @media (min-width: 2560px) {
    padding: ${({ preview }) => (preview ? '18px' : '32px')};
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: ${({ preview }) => (preview ? '4px' : '16px')};
  margin-top: '0';

  @media (max-width: 768px) {
    margin-bottom: ${({ preview }) => (preview ? '8px' : '12px')};
  }

  @media (max-width: 480px) {
    margin-bottom: ${({ preview }) => (preview ? '6px' : '8px')};
  }

  @media (min-width: 1200px) {
    margin-bottom: ${({ preview }) => (preview ? '6px' : '18px')};
  }

  @media (min-width: 1440px) {
    margin-bottom: ${({ preview }) => (preview ? '8px' : '20px')};
  }

  @media (min-width: 1680px) {
    margin-bottom: ${({ preview }) => (preview ? '2px' : '16px')};
  }

  @media (min-width: 1920px) {
    margin-bottom: ${({ preview }) => (preview ? '12px' : '24px')};
  }
`;

export const Logo = styled.div`
  display: flex;
  width: 100%;
  border-radius: 4px;

  & img {
    padding: ${({ preview }) => (preview ? '4px 0' : '30px 0')};
    max-width: ${({ preview }) => (preview ? '30%' : '70%')};
    max-height: ${({ preview }) => (preview ? '4vw' : '12vw')};
    margin: auto;
    object-fit: contain;

    @media (max-width: 768px) {
      padding: ${({ preview }) => (preview ? '2px 0' : '20px 0')};
      max-width: ${({ preview }) => (preview ? '25%' : '60%')};
      max-height: ${({ preview }) => (preview ? '3vw' : '10vw')};
    }

    @media (max-width: 480px) {
      max-width: ${({ preview }) => (preview ? '20%' : '50%')};
      max-height: ${({ preview }) => (preview ? '2.5vw' : '8vw')};
    }
    @media (min-width: 1920px) {
      padding: ${({ preview }) => (preview ? '16px 0' : '45px 0')};
      max-width: ${({ preview }) => (preview ? '35%' : '60%')};
      max-height: ${({ preview }) => (preview ? '6vw' : '12vw')};
    }
    @media (min-width: 2560px) {
      /* 1440p */
      padding: ${({ preview }) => (preview ? '20px 0' : '50px 0')};
      max-width: ${({ preview }) => (preview ? '40%' : '60%')};
      max-height: ${({ preview }) => (preview ? '7vw' : '12vw')};
    }
  }
`;

export const Greeting = styled.div`
  font-size: ${({ preview }) => (preview ? '12px' : '22px')};
  font-weight: 600;
  margin: ${({ preview }) => (preview ? '4px' : '30px')} 0;
  text-align: left;
  color: #333;

  @media (max-width: 768px) {
    font-size: ${({ preview }) => (preview ? '11px' : '18px')};
    margin: ${({ preview }) => (preview ? '3px' : '20px')} 0;
  }

  @media (max-width: 480px) {
    font-size: ${({ preview }) => (preview ? '10px' : '16px')};
    margin: ${({ preview }) => (preview ? '2px' : '16px')} 0;
  }

  @media (min-width: 1200px) {
    font-size: ${({ preview }) => (preview ? '12px' : '22px')};
    margin: ${({ preview }) => (preview ? '4px' : '30px')} 0;
  }

  @media (min-width: 1920px) {
    /* 1080p */
    font-size: ${({ preview }) => (preview ? '16px' : '22px')};
    margin: ${({ preview }) => (preview ? '8px' : '40px')} 0;
  }

  @media (min-width: 2560px) {
    /* 1440p */
    font-size: ${({ preview }) => (preview ? '22px' : '22px')};
    margin: ${({ preview }) => (preview ? '12px' : '48px')} 0;
  }
`;

export const FormHeader = styled.div`
  line-height: ${({ preview }) => (preview ? '1.3' : '1.5')};
  margin: ${({ preview }) => (preview ? '8px' : '30px')} 0;
  text-align: left;
  font-size: ${({ preview }) => (preview ? '10px' : '16px')};

  @media (max-width: 768px) {
    font-size: ${({ preview }) => (preview ? '10px' : '14px')};
    margin: ${({ preview }) => (preview ? '6px' : '20px')} 0;
    line-height: ${({ preview }) => (preview ? '1.2' : '1.4')};
  }

  @media (max-width: 480px) {
    font-size: ${({ preview }) => (preview ? '9px' : '12px')};
    margin: ${({ preview }) => (preview ? '4px' : '16px')} 0;
    line-height: ${({ preview }) => (preview ? '1.1' : '1.3')};
  }

  @media (min-width: 1200px) {
    font-size: ${({ preview }) => (preview ? '9px' : '17px')};
    margin: ${({ preview }) => (preview ? '4px' : '25px')} 0;
  }

  @media (min-width: 1440px) {
    font-size: ${({ preview }) => (preview ? '10px' : '18px')};
    margin: ${({ preview }) => (preview ? '3px' : '35px')} 0;
  }

  @media (min-width: 1680px) {
    font-size: ${({ preview }) => (preview ? '10px' : '16px')};
    margin: ${({ preview }) => (preview ? '2px' : '20px')} 0;
  }

  @media (min-width: 1920px) {
    /* 1080p */
    font-size: ${({ preview }) => (preview ? '15px' : '22px')};
    margin: ${({ preview }) => (preview ? '10px' : '48px')} 0;
  }

  @media (min-width: 2560px) {
    /* 1440p */
    font-size: ${({ preview }) => (preview ? '20px' : '24px')};
    margin: ${({ preview }) => (preview ? '16px' : '56px')} 0;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ preview }) => (preview ? '0px' : '12px')};

  @media (max-width: 768px) {
    gap: ${({ preview }) => (preview ? '0px' : '8px')};
  }

  @media (max-width: 480px) {
    gap: ${({ preview }) => (preview ? '0px' : '6px')};
  }

  @media (min-width: 1200px) {
    gap: ${({ preview }) => (preview ? '0px' : '10px')};
  }

  @media (min-width: 1440px) {
    gap: ${({ preview }) => (preview ? '0px' : '12px')};
  }

  @media (min-width: 1920px) {
    /* 1080p */
    gap: ${({ preview }) => (preview ? '6px' : '20px')};
  }

  @media (min-width: 2560px) {
    /* 1440p */
    gap: ${({ preview }) => (preview ? '10px' : '24px')};
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ preview }) => (preview ? '0px' : '6px')};
  color: #8e8e8e;

  @media (min-width: 1200px) {
    margin-bottom: ${({ preview }) => (preview ? '0px' : '6px')};
  }

  @media (min-width: 1440px) {
    margin-bottom: ${({ preview }) => (preview ? '0px' : '8px')};
  }

  
   @media (min-width: 1920px) { /* 1080p */
    margin-bottom: ${({ preview }) => (preview ? '6px' : '12px')};
  }

  @media (min-width: 2560px) { /* 1440p */
    margin-bottom: ${({ preview }) => (preview ? '8px' : '14px')};
  }

  .MuiTextField-root {
    width: 100%;
  }

  .MuiInputLabel-root {
    font-size: ${({ preview }) => (preview ? '10px' : '13px')};

    @media (max-width: 768px) {
      font-size: ${({ preview }) => (preview ? '9px' : '12px')};
    }

    @media (max-width: 480px) {
      font-size: ${({ preview }) => (preview ? '8px' : '11px')};
    }

    @media (min-width: 1440px) {
      font-size: ${({ preview }) => (preview ? '14px' : '15px')};
    }

    @media (min-width: 1920px) { /* 1080p */
      font-size: ${({ preview }) => (preview ? '16px' : '18px')};
    }

    @media (min-width: 2560px) { /* 1440p */
      font-size: ${({ preview }) => (preview ? '18px' : '19px')};
    }
  }

  .MuiFormHelperText-root {
    margin: ${({ preview }) => (preview ? '1px 0 0 0' : '2px 0 0 0')};
    font-size: ${({ preview }) => (preview ? '9px' : '12px')};

    @media (max-width: 768px) {
      font-size: ${({ preview }) => (preview ? '8px' : '11px')};
    }

    @media (max-width: 480px) {
      font-size: ${({ preview }) => (preview ? '7px' : '10px')};
    }

     @media (min-width: 1920px) { /* 1080p */
      font-size: ${({ preview }) => (preview ? '12px' : '14px')};
    }

    @media (min-width: 2560px) { /* 1440p */
      font-size: ${({ preview }) => (preview ? '14px' : '15px')};
    }
  }

  .MuiOutlinedInput-root {
    border-radius: ${({ preview }) => (preview ? '7px' : '12px')} !important;

    ${({ preview }) =>
      preview &&
      `
      .MuiOutlinedInput-input {
        padding: 3px 6px;
        font-size: 9px;
      }
    `}

    @media (max-width: 768px) {
      .MuiOutlinedInput-input {
        padding: ${({ preview }) => (preview ? '2px 4px' : '8px 12px')};
        font-size: ${({ preview }) => (preview ? '8px' : '14px')};
      }
    }

    @media (max-width: 480px) {
      .MuiOutlinedInput-input {
        padding: ${({ preview }) => (preview ? '1px 3px' : '6px 10px')};
        font-size: ${({ preview }) => (preview ? '7px' : '13px')};
      }
    }

    @media (min-width: 1440px) {
      .MuiOutlinedInput-input {
        padding: ${({ preview }) => (preview ? '6px 12px' : '12px 16px')};
        font-size: ${({ preview }) => (preview ? '11px' : '16px')};
      }
    }

    @media (min-width: 1920px) {
      .MuiOutlinedInput-input {
        padding: ${({ preview }) => (preview ? '12px 18px' : '16px 20px')};
        font-size: ${({ preview }) => (preview ? '14px' : '18px')};
      }
    }

    @media (min-width: 2560px) { /* 1440p */
      .MuiOutlinedInput-input {
        padding: ${({ preview }) => (preview ? '14px 20px' : '18px 22px')};
        font-size: ${({ preview }) => (preview ? '16px' : '20px')};
      }
  }
`;

export const FormLabel = styled.label`
  font-size: ${({ preview }) => (preview ? '10px' : '14px')};
  margin-bottom: ${({ preview }) => (preview ? '2px' : '4px')};
  color: #8e8e8e;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: ${({ preview }) => (preview ? '9px' : '13px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '3px')};
  }

  @media (max-width: 480px) {
    font-size: ${({ preview }) => (preview ? '8px' : '12px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '2px')};
  }

  @media (min-width: 1440px) {
    font-size: ${({ preview }) => (preview ? '8px' : '12px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '2px')};
  }

  @media (min-width: 1920px) {
    /* 1080p */
    font-size: ${({ preview }) => (preview ? '18px' : '18px')};
    margin-bottom: ${({ preview }) => (preview ? '6px' : '6px')};
  }

  @media (min-width: 2560px) {
    /* 1440p */
    font-size: ${({ preview }) => (preview ? '20px' : '20px')};
    margin-bottom: ${({ preview }) => (preview ? '8px' : '8px')};
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ preview }) => (preview ? '6px' : '10px')};
  margin-bottom: ${({ preview }) => (preview ? '1px' : '16px')};

  input[type='checkbox'] {
    width: ${({ preview }) => (preview ? '12px' : '16px')};
    height: ${({ preview }) => (preview ? '12px' : '16px')};
    cursor: ${({ preview }) => (preview ? 'default' : 'pointer')};
    accent-color: #2f80ed;
    margin-top: 0;

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }

    @media (max-width: 768px) {
      width: ${({ preview }) => (preview ? '10px' : '14px')};
      height: ${({ preview }) => (preview ? '10px' : '14px')};
      margin-top: 1px;
    }

    @media (max-width: 480px) {
      width: ${({ preview }) => (preview ? '8px' : '12px')};
      height: ${({ preview }) => (preview ? '8px' : '12px')};
      margin-top: 1px;
    }

    @media (min-width: 1920px) {
      width: ${({ preview }) => (preview ? '12px' : '14px')};
      height: ${({ preview }) => (preview ? '12px' : '14px')};
      margin-top: 1px;
    }
    @media (min-width: 2560px) {
      width: ${({ preview }) => (preview ? '14px' : '15px')};
      height: ${({ preview }) => (preview ? '14px' : '15px')};
      margin-top: 1px;
    }
  }

  label {
    font-size: ${({ preview }) => (preview ? '7px' : '14px')};
    color: #666;
    cursor: ${({ preview }) => (preview ? 'default' : 'pointer')};
    margin: 0;
    line-height: ${({ preview }) => (preview ? '1.2' : '1.4')};

    @media (max-width: 768px) {
      font-size: ${({ preview }) => (preview ? '6px' : '12px')};
      line-height: ${({ preview }) => (preview ? '1.1' : '1.3')};
    }

    @media (max-width: 480px) {
      font-size: ${({ preview }) => (preview ? '5px' : '11px')};
      line-height: ${({ preview }) => (preview ? '1.0' : '1.2')};
    }

    @media (min-width: 1200px) {
      font-size: ${({ preview }) => (preview ? '6px' : '13px')};
      line-height: ${({ preview }) => (preview ? '1.1' : '1.3')};
    }
    @media (min-width: 1440px) {
      font-size: ${({ preview }) => (preview ? '7px' : '14px')};
      line-height: ${({ preview }) => (preview ? '1.2' : '1.4')};
    }
    @media (min-width: 1680px) {
      font-size: ${({ preview }) => (preview ? '8px' : '15px')};
      line-height: ${({ preview }) => (preview ? '1.3' : '1.5')};
    }
    @media (min-width: 1920px) {
      /* 1080p */
      font-size: ${({ preview }) => (preview ? '12px' : '16px')};
      line-height: ${({ preview }) => (preview ? '1.4' : '1.6')};
    }
    @media (min-width: 2560px) {
      /* 1440p */
      font-size: ${({ preview }) => (preview ? '15px' : '17px')};
      line-height: ${({ preview }) => (preview ? '1.5' : '1.7')};
    }
  }

  @media (max-width: 768px) {
    gap: ${({ preview }) => (preview ? '4px' : '8px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '12px')};
  }

  @media (max-width: 480px) {
    gap: ${({ preview }) => (preview ? '3px' : '6px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '8px')};
  }
  @media (min-width: 1200px) {
    gap: ${({ preview }) => (preview ? '5px' : '9px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '14px')};
  }
  @media (min-width: 1440px) {
    gap: ${({ preview }) => (preview ? '6px' : '10px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '16px')};
  }
  @media (min-width: 1680px) {
    gap: ${({ preview }) => (preview ? '7px' : '11px')};
    margin-bottom: ${({ preview }) => (preview ? '1px' : '12px')};
  }
  @media (min-width: 1920px) {
    /* 1080p */
    gap: ${({ preview }) => (preview ? '12px' : '12px')};
    margin-bottom: ${({ preview }) => (preview ? '6px' : '20px')};
  }
  @media (min-width: 2560px) {
    /* 1440p */
    gap: ${({ preview }) => (preview ? '14px' : '14px')};
    margin-bottom: ${({ preview }) => (preview ? '8px' : '24px')};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: ${({ preview }) => (preview ? '8px' : '50px')};
  margin-top: ${({ preview }) => (preview ? '12px' : '0px')};

  @media (max-width: 768px) {
    margin-bottom: ${({ preview }) => (preview ? '10px' : '30px')};
    margin-top: ${({ preview }) => (preview ? '8px' : '0px')};
  }

  @media (max-width: 480px) {
    margin-bottom: ${({ preview }) => (preview ? '8px' : '20px')};
    margin-top: ${({ preview }) => (preview ? '6px' : '0px')};
  }

  @media (min-width: 1200px) {
    margin-bottom: ${({ preview }) => (preview ? '10px' : '40px')};
    margin-top: ${({ preview }) => (preview ? '14px' : '0px')};
  }

  @media (min-width: 1440px) {
    margin-bottom: ${({ preview }) => (preview ? '12px' : '50px')};
    margin-top: ${({ preview }) => (preview ? '16px' : '0px')};
  }

  @media (min-width: 1680px) {
    margin-bottom: ${({ preview }) => (preview ? '10px' : '30px')};
    margin-top: ${({ preview }) => (preview ? '14px' : '0px')};
  }

  @media (min-width: 1920px) {
    margin-bottom: ${({ preview }) => (preview ? '14px' : '50px')};
    margin-top: ${({ preview }) => (preview ? '18px' : '0px')};
  }
  @media (min-width: 2560px) {
    /* 1440p */
    margin-bottom: ${({ preview }) => (preview ? '18px' : '60px')};
    margin-top: ${({ preview }) => (preview ? '22px' : '0px')};
  }
`;

export const SignUpButton = styled.button`
  padding: ${({ preview }) => (preview ? '1px 8px' : '6px 30px')};
  min-width: ${({ preview }) => (preview ? '80px' : '200px')};
  background: #007ade;
  color: white;
  border: none;
  border-radius: ${({ preview }) => (preview ? '4px' : '11px')};
  font-size: ${({ preview }) => (preview ? '8px' : '14px')};
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: ${({ preview }) => (preview ? 'default' : 'pointer')};
  opacity: 1;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: ${({ preview }) =>
    preview ? '0 2px 4px rgba(0, 122, 222, 0.3)' : 'none'};

  &:hover {
    background: ${({ preview }) => (!preview ? '#1e6fd8' : '#007ade')};
    box-shadow: ${({ preview }) =>
      preview ? '0 3px 6px rgba(0, 122, 222, 0.4)' : 'none'};
  }

  &:disabled {
    background: ${({ preview }) => (preview ? '#007ade' : '#d3d3d3')};
    color: white;
    cursor: default;
    box-shadow: ${({ preview }) =>
      preview ? '0 2px 4px rgba(0, 122, 222, 0.3)' : 'none'};
  }

  @media (max-width: 768px) {
    padding: ${({ preview }) => (preview ? '1px 6px' : '5px 24px')};
    min-width: ${({ preview }) => (preview ? '70px' : '160px')};
    font-size: ${({ preview }) => (preview ? '7px' : '13px')};
  }

  @media (max-width: 480px) {
    padding: ${({ preview }) => (preview ? '1px 4px' : '4px 20px')};
    min-width: ${({ preview }) => (preview ? '60px' : '140px')};
    font-size: ${({ preview }) => (preview ? '6px' : '12px')};
  }

  @media (min-width: 1200px) {
    padding: ${({ preview }) => (preview ? '1px 10px' : '6px 30px')};
    min-width: ${({ preview }) => (preview ? '90px' : '200px')};
    font-size: ${({ preview }) => (preview ? '9px' : '14px')};
  }

  @media (min-width: 1440px) {
    padding: ${({ preview }) => (preview ? '2px 12px' : '8px 35px')};
    min-width: ${({ preview }) => (preview ? '100px' : '220px')};
    font-size: ${({ preview }) => (preview ? '10px' : '16px')};
  }

  @media (min-width: 1920px) {
    padding: ${({ preview }) => (preview ? '6px 18px' : '10px 40px')};
    min-width: ${({ preview }) => (preview ? '130px' : '240px')};
    font-size: ${({ preview }) => (preview ? '15px' : '18px')};
  }

  @media (min-width: 2560px) {
    /* 1440p */
    padding: ${({ preview }) => (preview ? '8px 22px' : '14px 50px')};
    font-size: ${({ preview }) => (preview ? '16px' : '22px')};
    min-width: ${({ preview }) => (preview ? '150px' : '280px')};
  }
`;

export const Disclaimer = styled.div`
  font-size: ${({ preview }) => (preview ? '5px' : '13px')};
  font-family: Montserrat;
  padding-top: ${({ preview }) => (preview ? '2px' : '24px')};
  color: #616161;
  padding-bottom: ${({ preview }) => (preview ? '1px' : '50px')};
  line-height: ${({ preview }) => (preview ? '1.1' : '1.4')};
  white-space: normal;
  word-wrap: break-word;
  text-align: justify;

  @media (max-width: 768px) {
    font-size: ${({ preview }) => (preview ? '7px' : '11px')};
    padding-top: ${({ preview }) => (preview ? '8px' : '16px')};
    padding-bottom: ${({ preview }) => (preview ? '6px' : '30px')};
    line-height: ${({ preview }) => (preview ? '1.2' : '1.3')};
  }

  @media (max-width: 480px) {
    font-size: ${({ preview }) => (preview ? '6px' : '10px')};
    padding-top: ${({ preview }) => (preview ? '6px' : '12px')};
    padding-bottom: ${({ preview }) => (preview ? '4px' : '20px')};
    line-height: ${({ preview }) => (preview ? '1.1' : '1.2')};
  }

  @media (min-width: 1200px) {
    font-size: ${({ preview }) => (preview ? '6px' : '12px')};
    padding-top: ${({ preview }) => (preview ? '4px' : '20px')};
    padding-bottom: ${({ preview }) => (preview ? '2px' : '40px')};
  }

  @media (min-width: 1440px) {
    font-size: ${({ preview }) => (preview ? '6px' : '13px')};
    padding-top: ${({ preview }) => (preview ? '3px' : '24px')};
    padding-bottom: ${({ preview }) => (preview ? '2px' : '50px')};
  }

  @media (min-width: 1680px) {
    font-size: ${({ preview }) => (preview ? '5px' : '11px')};
    padding-top: ${({ preview }) => (preview ? '1px' : '15px')};
    padding-bottom: ${({ preview }) => (preview ? '1px' : '25px')};
  }

  @media (min-width: 1920px) {
    font-size: ${({ preview }) => (preview ? '10px' : '15px')};
    line-height: 1.5;
    padding-top: ${({ preview }) => (preview ? '4px' : '24px')};
    padding-bottom: ${({ preview }) => (preview ? '3px' : '50px')};
  }

  @media (min-width: 2560px) {
    /* 1440p */
    font-size: ${({ preview }) => (preview ? '13px' : '16px')};
    line-height: 1.6;
    padding-top: ${({ preview }) => (preview ? '14px' : '28px')};
    padding-bottom: ${({ preview }) => (preview ? '6px' : '70px')};
  }
`;

export const PolicyLink = styled.a`
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${props => (props.$disabled ? 'none' : 'auto')};
  color: #616161;
  text-decoration: underline;

  &:hover {
    color: #616161;
  }
`;

export const MessageContainer = styled.div`
  display: ${({ preview }) => (preview ? 'none' : 'block')};
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  font-family: 'Poppins', sans-serif;
  min-height: 20px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-top: 6px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-top: 4px;
  }
`;

export const Message = styled.span`
  color: ${({ type }) => (type === 'success' ? '#28a745' : '#dc3545')};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  margin-top: 8px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-top: 6px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-top: 4px;
  }
`;
